import { IExportColumnModel } from "../../../../../shared/models";

export const EmailTemplatesColumnList: IExportColumnModel[] = [
]